<template>
    <div class="subject-box">
        <div
            class="row"
            :class="{'template': !isMyCourse}"
        >
            <p class="name">{{type === '我的课件'?'学科': '模版分类'}}：</p>
            <el-select
                    v-if="isMyCourse"
                    v-model="subjectSelect"
                    class="select"
                    placeholder="请选择"
                    size="medium"
                    :popper-class="isTheme?'school-center':''"
                    :clearable="true"
                    @change="handleSelectSubject(subjectSelect)"
                    @clear="catalogSelect=0;newSelect=0"
            >
                <el-option
                        v-for="(item2) in optionsSubject"
                        :key="item2.id"
                        :label="item2.name"
                        :value="item2.id">
                </el-option>
            </el-select>
        </div>
        <div class="row">
            <p v-if="isMyCourse" class="name">分类：</p>
            <el-cascader
                    v-model="catalogSelect"
                    size="medium"
                    :popper-class="isTheme?'school-center':''"
                    :options="optionsCatalog"
                    :props="{expandTrigger: 'hover'}"
                    :clearable="true"
                    @change="handleChange(catalogSelect)"></el-cascader>
        </div>
        <div
            v-if="isMyCourse"
            class="row">
            <p class="name">发布状态：</p>
            <el-select
                    v-model="packageState"
                    class="select"
                    placeholder="请选择"
                    size="medium"
                    :popper-class="isTheme?'school-center':''"
                    :clearable="true"
                    @change="handlerSelectState(packageState)"
            >
                <el-option
                        v-for="(item2) in packageStatus"
                        :key="item2.id"
                        :label="item2.name"
                        :value="item2.id">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    import * as CourseServer from '../../../../api/course'
    import * as CommonServer from "../../../../api/common";
    export default {
        name: "subject",
        props: {
            isTheme: {
                type: Boolean,
                default: false
            },
            select: [String,Number],
            type: String,
            typeIndex: [String, Number]
        },
        watch: {
            type(){
                this.init()
            },
            select(vl){this.newSelect = vl},
            newSelect(vl){this.$emit('update:select',vl)},
            typeIndex(vl){this.newTypeIndex = vl},
            newTypeIndex(vl){this.$emit('update:typeIndex',vl)}
        },
        computed: {
            isMyCourse(){
                return [this.$enums.LIST_TYPE.myCourse].includes(this.type)
            }
        },
        created() {
            this.init()
        },
        data() {
            return {
                newSelect: this.select,
                newTypeIndex: this.typeIndex,
                subjectSelect: '', // 学科选中
                optionsSubject: [], // 学科筛选
                catalogSelect: '', // 目录选中
                optionsCatalog: [], // 目录筛选
                packageState: '', // 选中打包状态
                packageStatus: [
                    {id: 'success', name: '成功'},
                    {id: 'failure', name: '失败'},
                    {id: 'unpublished', name: '未发布'},
                    {id: 'run', name: '打包中'}
                ]
            }
        },
        methods:{
            setOptions({data}){
                return this.$utils.oldTree2NewTree({data, oldKeys: ['childrens', 'id', 'name'], newKeys: ['children', 'value', 'label']})
            },
            async init(){
                this.clearAll()
                // if (!this.$store.state.permission) {
                //     return false
                // }

                let res = null
                switch (this.type) {
                    case this.$enums.LIST_TYPE.myCourse: {
                        res = await CourseServer.getCourseTypeList({
                            clientsId: this.$store.state.initConfig.school_id,
                            per_page: 1000
                        })
                        console.log('我的课件==>', res)
                        this.optionsSubject = res.items
                        this.$emit('onSubjectOptions', res.items)
                        break;
                    }
                    case this.$enums.LIST_TYPE.myTemplate:
                        res = await CommonServer.default.getResourceCategoryTree({
                            clientsId: this.$store.state.initConfig.school_id,
                            sort: 'template'
                        })
                        console.log('我的模版==>', res)
                        this.optionsCatalog = this.setOptions({data: res.data})
                        break;
                    case this.$enums.LIST_TYPE.platTemplate:
                        res = await CommonServer.default.getResourceCategoryShopTree({
                            clientsId: this.$store.state.initConfig.school_id,
                            sort: 'template'
                        })
                        console.log('平台模版==>', res)
                        this.optionsCatalog = this.setOptions({data: res.data})
                        break;
                    default:
                }
            },
            // 选中学科 联动 分类
            async handleSelectSubject(id){
                const res = await CourseServer.getCourseRuleList({
                    clientsId: this.$store.state.initConfig.school_id,
                    parentId: id
                })
                console.log('我的课件-2==>', res)
                let newData = this.setOptions({data:res.data.childrens})
                this.optionsCatalog = newData
                this.newSelect = ''
            },
            // 发布状态变更
            handlerSelectState(state){
                this.$emit('onPackState', state)
            },
            // 课件分类选中 / 模版目录选中
            handleChange(catalogId){
                if(catalogId.length === 0 && this.type === '我的课件'){
                    this.subjectSelect = ''
                }
                console.log('目录选中==>', catalogId)
                this.newSelect = catalogId[catalogId.length - 1]
            },
            clearAll(){
                this.subjectSelect = '' // 学科选中
                this.optionsSubject = [] // 学科筛选
                this.catalogSelect = '' // 目录选中
                this.optionsCatalog = [] // 目录筛选
                this.packageState = '' // 选中打包状态
            }
        }
    }
</script>

<style lang="scss" scoped>
.subject-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 30px 0px;

    .row{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 30px;

        &.template{
            margin-right: 0;
        }
    }

    .name, .dropdown{
        font-size:14px;
        color:rgba(51,51,51,1);
        margin-right: 10px;
        flex-wrap: nowrap;
        display: flex;
        flex-shrink: 0;
    }
    .el-dropdown-link{
        cursor: pointer;
    }

    .select-box{
        .select {
            margin-right: 10px;
        }
    }
}
</style>
